import { useEffect } from "react";
import {
  Notification,
  NotificationContainer,
  NotificationMainContainer,
  NotificationRead,
} from "./notification.styled";
import Error from "../error";

import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";
import moment from "moment";
interface NotificationsProps {
  getNotificationCount?: any // Adjust the type based on your actual prop type
}
const Notifications: React.FC<NotificationsProps> = ({ getNotificationCount }) => {
  useEffect(() => {
    General.getNotifications({ errorId: 'notificationsError', data: { start: 1, perPage: 100 } })
    return () => {
      getNotificationCount()
    };
  }, [])
  const compareDates = (lastTimeStamp: any, notificationDateTime: any) => {
    console.log(lastTimeStamp, notificationDateTime)
    const formatedNotification = moment(notificationDateTime, moment.defaultFormat)
    const formatedLastTimestamo = moment(lastTimeStamp, moment.defaultFormat)
    const formattedNotificationDateTime = moment(notificationDateTime).format("YYYY-MM-DD:HH:mm:ss");
    const lastTimeStampDate = new Date(lastTimeStamp);
    const notificationDateTimeDate = new Date(formattedNotificationDateTime);

    return (formatedNotification > formatedLastTimestamo);
  };
  function isNotificationRecent(notification: any) {
    // Get the current date
    const currentDate: any = new Date();
    
    // Extract the notification date from the notification object
    const notificationDateStr = notification?.notificationDateTime;
    
    // Ensure the notificationDateStr is valid before proceeding
    if (!notificationDateStr) {
        console.error("Invalid notification date string");
        return false;
    }

    // Parse the notification date (assuming the format is "YYYY-MM-DD-HH.mm.ss")
    const [year, month, day] = notificationDateStr.split('-').slice(0, 3).map(Number);

    // Ensure year, month, and day are valid numbers
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
        console.error("Invalid date components in notification");
        return false;
    }

    // Create a Date object for the notification date
    const notificationDate: any = new Date(year, month - 1, day); // JS months are 0-indexed

    // Calculate the difference in time (milliseconds)
    const timeDiff = currentDate - notificationDate;
    
    // Convert milliseconds to months (approximate, assuming 30.44 days in a month)
    const monthsDiff = timeDiff / (1000 * 60 * 60 * 24 * 30.44);

    // Return true if the notification is less than 3 months old, false otherwise
    // console.log("monthsDiff" ,monthsDiff < 3)
    return monthsDiff < 3;
  }
  function isLatest(notificationDate: any) {
    
    if (!notificationDate || !General.latTimeStamp) return false;
    
    const notificationMoment = moment(notificationDate, "YYYY-MM-DDTHH:mm:ss");
    const lastTimestampMoment = moment(General.latTimeStamp, "YYYY-MM-DDTHH:mm:ss");
    console.log("notificationMoment", notificationMoment.format("YYYY-MM-DDTHH:mm:ss"));
    console.log("lastTimestampMoment", lastTimestampMoment.format("YYYY-MM-DDTHH:mm:ss"));
    
    return notificationMoment > lastTimestampMoment;
  }
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (

    <NotificationMainContainer>
      <div style={{
        backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : "#E7E9F8",
        width: "100vw",
        minHeight: "20vh",
        display: "flex",
      }}>
        <div style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "1rem",
          marginLeft: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "" : General?.isLargeScreen ? "80px" : '1rem',
          marginRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? General?.isLargeScreen ? "80px" : '1rem' : "",
          paddingTop: "20px"
        }}>
          <h1 style={{
            fontFamily: 'Segoe UI',
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: `${2.75 * General.accessibility.fontSize}rem`,
            lineHeight: "48px",
            padding: "0",
            margin: "0",
            color: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss,
          }}>
            {General?.codeLabels["cm_mob_notification"]?.label !== undefined ? General?.codeLabels["cm_mob_notification"]?.label : "Notifications"}
          </h1>
          <p style={{
            fontFamily: 'Segoe UI',
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: `${0.875 * General.accessibility.fontSize}rem`,
            lineHeight: "14px",
            padding: "0",
            margin: "0",
            color: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss,
          }}>{General?.codeLabels["cm_notificaion_view"]?.label ? General?.codeLabels["cm_notificaion_view"]?.label : "View all your notifications, be informed and / or take action"}</p>
        </div>
      </div>
      <Error id="notificationsError" />

      <p style={{
        display: "flex",
        justifyContent: "center",
        width: "20vw",
        fontFamily: 'Segoe UI',
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "20px",
        color: contrast?.contrastColor
          ? contrast?.contrastColor
          : ColorAss,
      }}>
        {/* <b>2 New Notifications</b> */}
      </p>
      <NotificationContainer style={{ overflowY: 'auto', height: General?.isLargeScreen ? '100vh' : "", overflowX: '-moz-hidden-unscrollable' }}>
        {
          General.notifications.list.length > 0
            ? General.notifications.list
              .filter(notification => !notification.notificationDescr?.includes("Email to be sent via BI Publisher"))
              .map((notification) => {
                var isNotificationNewer;
                isNotificationNewer = isNotificationRecent(notification);
                const latest = isLatest(notification.notificationDateTime);
                console.log("latest", latest)
                const backgroundColor = latest ? (contrast?.contrastBackground ? contrast?.contrastBackground : '#E8F5E9')  // Unread notification background
                : (contrast?.contrastBackground ? contrast?.contrastBackground : '#FFFFFF');  // Read notification background;
                const borderColor = isNotificationNewer ? contrast?.contrastColor ? contrast?.contrastColor :'#62AA51' : contrast?.contrastBackground ? contrast?.contrastBackground :'white';
                return <Notification style={{ borderLeft: `6px solid ${borderColor}`, wordBreak: "break-word", padding: "0.2rem 1rem",background: backgroundColor }}>
                  <div style={{ fontSize: General?.isLargeScreen ? '' : `${0.7 * General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, background: backgroundColor }} dangerouslySetInnerHTML={{ __html: notification.notificationDescr }} ></div>
                  <p
                     style={{ width: '20%', textAlign: 'end', fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss, }}>{moment(notification.notificationDateTime, moment.defaultFormat).fromNow()}</p>
                </Notification>
              })
            : <p style={{ fontSize: `${General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}> {General?.codeLabels["cm_notificaion_no"]?.label ? General?.codeLabels["cm_notificaion_no"]?.label : "You have no notifications"}</p>
        }
      </NotificationContainer>
    </NotificationMainContainer>

  );
};

export default observer(Notifications);


